import { useState } from "react";
import { Button } from "../ui/button";
import { useFormik } from "formik";
import usePasswordChangeMutation from "@/api/mutation/usePasswordChangeMutation";
import { toast } from "react-toastify";
import { isAxiosError } from "axios";

import { z } from "zod";
import { changePasswordSchema } from "@backend/src/schemas/userSchema";
import { toFormikValidationSchema } from "zod-formik-adapter";
import InputPassword from "../common/inputPassword";
import FormLabel from "../common/FormLabel";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";

function ChangePassword() {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState(true);
  const passwordMutation = usePasswordChangeMutation();
  const errorStyle = "text-red-400 block text-sm h-1";
  const inputStyle =
    "relative py-1.5 px-3 rounded-md border border-gray-100 w-full h-[40px]"; 
  const formik = useFormik<z.infer<typeof changePasswordSchema>>({
    initialValues: {
      oldPassword: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: toFormikValidationSchema(changePasswordSchema),
    onSubmit: (values, helper) => {
      passwordMutation.mutate(values, {
        onSuccess(data) {
          formik.resetForm();
          setIsSubmitting(false);
          setIsUpdate(true);
          toast.success(t(data.data.message));
        },
        onError(error) {
          setIsSubmitting(false);
          if (isAxiosError(error)) {
            if (
              error.response?.status === 400 &&
              error.response.data?.errors &&
              Array.isArray(error.response?.data.errors)
            ) {
              error.response.data.errors.forEach((item) => {
                helper.setFieldError(item.path[0], item.message);
              });
            }
            if (!Array.isArray(error.response?.data.errors)) {
              toast.error(
                errorKeyFormate(error.response?.data.message+''),
                errorConfig
              );
            }
          }
        },
      });
    },
  });

  return (
    <>
      <div className="p-4 overflow-y-auto lg:overflow-hidden max-h-screen">
        <div className="text-center text-gray-700 text-sm space-y-2 flex   flex-col items-center justify-center gap-5 p-1 rounded-2xl w-full">
          <div className="absolute right-3 top-0 flex  gap-2">
            {/* <Button
              className="text-[#ffff] bg-gray-450 p-1 border-2 h-14 w-28 rounded-xl"
              onClick={toggleFormReadability}
            >
              {isEditable ? "Edit" : "Cancel"}
            </Button> */}
            <Button
              size={"sm"}
              className="text-white bg-gray-450"
              onClick={() => setIsUpdate((prev) => !prev)}
            >
              {isUpdate ? t("edit") : t("cancel")}
            </Button>
            {!isUpdate ? (
              <div className="flex items-center @2xl:col-span-2">
                <Button
                  isLoading={isSubmitting}
                  variant={"primary"}
                  size={"sm"}
                  onClick={formik.submitForm}
                  className="ml-auto"
                  disabled={isSubmitting}
                >
                  {t("update")}
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <form onSubmit={(e) => e.preventDefault()} className="w-1/2">
          <div className="w-full grid grid-cols-2 gap-2">
            <div className="text-left col-span-2 mb-5">
              <FormLabel className="text-gray-450">
                {t("old_password")}
              </FormLabel>
              <div className="relative">
                <InputPassword
                  disabled={isUpdate}
                  name="oldPassword"
                  className={inputStyle}
                  value={formik.values.oldPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {!isUpdate && (
                <span className={errorStyle}>
                  {formik.touched.oldPassword && formik.errors.oldPassword}
                </span>
              )}
            </div>
            <div className="text-left">
              <FormLabel className="text-gray-450">
                {t("new_password")}
              </FormLabel>
              <div className="relative">
                <InputPassword
                  disabled={isUpdate}
                  name="password"
                  className={inputStyle}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {!isUpdate && (
                <span className={errorStyle}>
                  {formik.touched.password && formik.errors.password}
                </span>
              )}
            </div>
            <div className="text-left">
              <FormLabel className="text-gray-450">
                {t("confirm_password")}
              </FormLabel>
              <div className="relative">
                <InputPassword
                  disabled={isUpdate}
                  name="confirmPassword"
                  className={inputStyle}
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {!isUpdate && (
                <span className={errorStyle}>
                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword}
                </span>
              )}
            </div>
          </div>

          {/* {!isUpdate && formik.isValid && (
            <div className="flex justify-end gap-4 mt-4">
              <Button
                variant={"primary"}
                className="font-medium text-lg"
                isLoading={isSubmitting}
                disabled={isSubmitting}
                onClick={formik.submitForm}
              >
                Save
              </Button>
              <Button
                type="submit"
                variant={"primary_outline"}
                className="font-medium text-lg"
                onClick={handleClosePasswordPopUp}
                isLoading={isSubmitting}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
            </div>
          )} */}
        </form>
      </div>
    </>
  );
}

export default ChangePassword;
